if (!customElements.get('logo-list-carousel')) {
  class LogoListCarousel extends HTMLElement {
    constructor() {
      super();

      this.swiperInit();
    }

    swiperInit() {
      const carousel = this.querySelector('[data-swiper]');

      if (!carousel) { return; }

      const swiper = new window.Swiper(carousel, {
        spaceBetween: 16,
        centeredSlides: true,
        slidesPerView: 'auto',
        draggable: true,
        loop: true
      });

      return swiper;
    }
  }

  customElements.define('logo-list-carousel', LogoListCarousel);
}